import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import Sidebar, { SIDEBAR_WIDTH, SIDEBAR_WIDTH_COLLAPSED } from "./Sidebar";
import MobileTopNav, { MOBILE_NAV_HEIGHT } from "./MobileTopNav";
import VariantSwitcher from "../dev/VariantSwitcher";
import { getTenantType } from "../../tenant/tenant";

/**
 * Layout comun del dashboard (estructura de la web del psicologo): sidebar navy
 * fijo a la izquierda + area de contenido.
 *
 * Paradigmas de layout:
 * - Desktop (md+) en clinica: sin scroll, el area de contenido tiene alto fijo
 *   (viewport); el contenido debe caber (compactar / auto-ajuste de PagedView).
 * - Desktop en farma: SI se permite scroll vertical. El dashboard pharma tiene
 *   bastante mas densidad de datos por vista que clinica (varias tablas +
 *   graficos por modulo) y forzar que quepa todo sin scroll llevaba a contenido
 *   recortado e invisible (sin ninguna barra de scroll con la que alcanzarlo).
 *   Excepcion deliberada, no se aplica a clinica.
 * - Movil (<md): SI se permite scroll vertical siempre (el contenido se apila).
 * - Contenido pegado a la izquierda (sin centrar) para no dejar huecos laterales
 *   en resoluciones altas.
 * - Responsive: en movil el sidebar arranca contraido.
 */
function DashboardLayout() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [collapsed, setCollapsed] = useState(isMobile);
    const isFarma = getTenantType() === "farma";

    const sidebarWidth = collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH;

    return (
        <Box sx={{ height: "100vh", overflow: "hidden", bgcolor: "background.default" }}>
            {isMobile ? <MobileTopNav /> : <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />}

            <Box
                component="main"
                sx={{
                    ml: { xs: 0, md: `${sidebarWidth}px` },
                    transition: "margin-left 0.3s ease",
                    height: "100vh",
                    overflowY: { xs: "auto", md: isFarma ? "auto" : "hidden" },
                    overflowX: "hidden",
                    px: { xs: 2, md: 4 },
                    pt: { xs: `${MOBILE_NAV_HEIGHT + 16}px`, md: 2.5 },
                    pb: { xs: 2, md: 2.5 },
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Outlet />
            </Box>

            <VariantSwitcher />
        </Box>
    );
}

export default DashboardLayout;
